<pk-broker-loader [show]="loading"></pk-broker-loader>
<ng-container *ngIf="startValidation">
	<pk-broker-page-warnings [warnings]="warnings"></pk-broker-page-warnings>
	<div class="alert alert-warning" *ngIf="err.billingMethod">Billing Method is required.</div>
	<div class="alert alert-warning" *ngIf="err.bandwidthPercentage">Bandwidth Percentage is required.</div>
	<div class="alert alert-warning" *ngIf="err.isGRTIncluded">Please select if GRT is included.</div>
	<div class="alert alert-warning" *ngIf="productBidErrors">
		There is a problem with your product bids, please check above to validate all your fields.
	</div>
</ng-container>
<form id="submitBid" [formGroup]="formGroup" *ngIf="!loading">
	<div class="row">
		<div class="col-md-12 mb-4">
			<div class="card px-2 py-1">
				<div class="row">
					<div class="col-sm-3">
						<div class="form-element-container">
							<label class="title font-weight-bold">Start</label>
							<p class="value m-0">{{ rfqSession.startDate | date: 'MM/dd/yyyy' }} {{ rfqSession.startTime | date: 'hh:mm a' }} CT</p>
						</div>
					</div>
					<div class="col-sm-5">
						<div class="form-element-container">
							<label class="title font-weight-bold">End</label>
							<p class="value m-0">{{ rfqSession.formatEndDate() }} CT</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-md-12">
			<div class="table-responsive" style="overflow-x: unset">
				<table class="table table-sm table-bordered table-striped table-hover">
					<thead>
						<tr>
							<th class="text-center">Bandwidth</th>
							<th class="text-center">Billing Method</th>
							<th class="text-center">Units</th>
							<th class="text-center" *ngIf="showIsGRTIncluded">Is GRT Included?</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td class="text-center">
								<div class="form-element-container mb-0" [class.invalid]="err.bandwidthPercentage">
									<pk-broker-form-dropdown
										formControlName="bandwidthPercentage"
										[isRequired]="true"
										[options]="bandwidthPercentages"
										[textMap]="bandwidthPercentageTextMap"
										valueKey="value"
										nullOption="-- Select --">
									</pk-broker-form-dropdown>
								</div>
							</td>
							<td class="text-center">
								<div class="form-element-container mb-0" [class.invalid]="err.billingMethod">
									<pk-broker-form-dropdown
										formControlName="billingMethod"
										[isRequired]="true"
										[options]="billingMethods"
										valueKey="value"
										nullOption="-- Select --">
									</pk-broker-form-dropdown>
								</div>
							</td>
							<td class="text-center">
								<div class="form-element-container mb-0">
									<pk-broker-form-dropdown formControlName="units" [options]="bidMeasureUnits"></pk-broker-form-dropdown>
								</div>
							</td>
							<td class="text-center" *ngIf="showIsGRTIncluded">
								<div class="form-element-container mb-0" [class.invalid]="err.isGRTIncluded">
									<pk-broker-form-dropdown
										formControlName="isGRTIncluded"
										[isRequired]="true"
										[options]="[true, false]"
										[textMap]="yesNoTextMap"
										valueKey="value"
										nullOption="-- Select --">
									</pk-broker-form-dropdown>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="table-responsive" style="overflow-x: unset">
				<table class="table table-sm table-bordered table-striped table-hover" id="bidTable2">
					<thead>
						<tr>
							<th>{{ rfqSession.contract.serviceType.name }} Product(s)</th>
							@for (pricingComponent of pricingComponents; track pricingComponent.id) {
								<th nowrap="nowrap">{{ pricingComponent.name }}&nbsp;{{ form.units.value.text }}</th>
							}
							<th nowrap="nowrap">Bid Amount&nbsp;{{ form.units.value.text }}</th>
						</tr>
					</thead>
					<tbody>
						<ng-container formArrayName="productBids" *ngFor="let productBid of form.productBids; let i = index">
							<tr [formGroupName]="i">
								<td>
									<span class="product" [tooltip]="productBid.entity.value.product.description" placement="top">
										{{ getProductBidText(productBid) }}
									</span>
								</td>
								<ng-container formArrayName="rfqSessionBidPricingComponents" *ngFor="let pricingComponent of pricingComponents; let i = index">
									<td>
										<div [formGroupName]="i">
											<input class="form-control form-control-white" type="number" step="0.00001" formControlName="amount" />
										</div>
									</td>
								</ng-container>
								<td>
									<input class="form-control form-control-white" type="number" step="0.00001" formControlName="bidAmount" />
								</td>
							</tr>
							<tr>
								<td colspan="7">
									<div class="alert alert-warning" *ngIf="err.productBids[i].group?.bidAmountMinMax || err.productBids[i].bidAmount?.min">
										{{ generateErrorMessage(productBid.entity.value.productId) }}
									</div>
									<div class="alert alert-warning" *ngIf="err.productBids[i].group?.multipleDecimals">
										Please enter a valid number with one or fewer decimals.
									</div>
								</td>
							</tr>
						</ng-container>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</form>

<div class="row">
	<div class="col-sm-12 mb-4">
		<ul>
			<li class="text-danger">Broker Margin need to be included in all bids. Broker margin information can be found in the RFP info Excel Sheet</li>
			<li class="text-danger">For PA, GRT needs to be included for &lt;150,000 kWh deals, and should not be included for &gt;150,000 kWh deals.</li>
			<li class="text-danger">For NY & NJ, GRT and SUT need to be included.</li>
			<li class="text-danger">Please select the Bandwidth and Billing Method for your bids.</li>
			<li class="text-danger">For Index Adder Product, please list the items included and not included in the note area</li>
			<li class="text-danger">
				Please put notes in the note area, e.g. "Credit pending", "Dual billing only", "One of the accounts is removed", "start date has changed to
				xxx"
			</li>
		</ul>
		<div class="modal-table table-responsive">
			<table class="table table-sm table-bordered table-striped">
				<thead>
					<tr>
						<th>Special Instructions</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td class="w-75 pt-2 valign-top">
							<span class="text-success font-weight-bold">{{ rfqSession.instructions || 'N/A' }}</span>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<pk-broker-auction-supplier-create-bids-note [rfqSessionSupplier]="rfqSessionSupplier" [rfqSessionId]="rfqSession.rfqSessionId">
		</pk-broker-auction-supplier-create-bids-note>
	</div>
</div>

<div class="row" *ngIf="rfqSession.contract.awardDate && rfqSession.contract.supplierId === rfqSessionSupplier.supplierId">
	<div class="col-md-12">
		<pk-broker-auction-supplier-create-bids-attachment [rfqSession]="rfqSession" [supplierId]="supplierId">
		</pk-broker-auction-supplier-create-bids-attachment>
	</div>
</div>
